import { Component, Sprite, SpriteFrame, _decorator } from 'cc';
import { DEV } from 'cc/env';

const { ccclass, property, requireComponent, executeInEditMode } = _decorator;

@ccclass('SpriteContainer')
@requireComponent(Sprite)
@executeInEditMode
export default class SpriteContainer extends Component {
    @property
    private _fullyContained: boolean = false;

    private _onSpriteFrameChangedCallback = this._onSpriteFrameChanged.bind(this);
    private _sprite: Sprite = null;

    @property({ displayName: DEV && '是否完全包含圖片', tooltip: DEV && '圖片是否完全顯示在容器內' })
    public get fullyContained(): boolean {
        return this._fullyContained;
    }
    public set fullyContained(value: boolean) {
        if (this._fullyContained === value) {
            return;
        }
        this._fullyContained = value;
        this._onSpriteFrameChanged(this.sprite.spriteFrame);
    }

    private get sprite(): Sprite {
        if (!this._sprite) {
            this._sprite = this.getComponent(Sprite);
        }
        return this._sprite;
    }

    protected onLoad() {
        this.sprite.sizeMode = Sprite.SizeMode.CUSTOM;
        this.sprite.registerSpriteFrameChangeCallback(this._onSpriteFrameChangedCallback);
    }

    protected start() {
        this._onSpriteFrameChanged(this.sprite.spriteFrame);
    }

    protected onDestroy() {
        this.sprite.unregisterSpriteFrameChangeCallback(this._onSpriteFrameChangedCallback);
        this._sprite = null;
    }

    private _onSpriteFrameChanged(spriteFrame: SpriteFrame): SpriteFrame {
        if (spriteFrame) {
            const frameSize = spriteFrame.originalSize;
            const targetSize = this.node.transform.contentSize;
            const scaleX = targetSize.width / frameSize.width;
            const scaleY = targetSize.height / frameSize.height;
            const scale = this.fullyContained ? Math.min(scaleX, scaleY) : Math.max(scaleX, scaleY);
            this.node.setScale(scale / scaleX, scale / scaleY, 1);
        }
        return spriteFrame;
    }
}
